
export const useWarningModal = () => {

    const warning = useState<{
        title: string,
        body: string,
        callback?: Function,
    }|null>('warningState', () => null);

    const setWarning = (title: string, body: string, callback?: Function) => {
        warning.value = {
            title: title,
            body: body,
            callback: callback
        };
    }

    return {
        warning,
        setWarning,
    };
};